module.exports = __webpack_public_path__ + "static/media/star8.30bdfa10.svg";